import React from 'react'

/** Data and signatures have separate locks: the second signer can still sign. */
export const RoofClaimContext = React.createContext({
  locked: false,
  readOnly: false,
  isPDF: false,
  /** What the customer's own record fills in (13433630443). See RCInput. */
  autofill: {} as Readonly<Record<string, string>>,
  /** Boxes the rep emptied on purpose in this session: stay empty. */
  cleared: new Set<string>() as ReadonlySet<string>,
  onClearedChange: (_field: string, _cleared: boolean): void => {},
})
